import Table from "./Table";
import PageLoader from './PageLoader';
import debounce from "lodash.debounce";
import { makeStyles } from "@mui/styles";
import { FaSearch } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getContactUs } from "../redux/user/user.slice";
import { useEffect, useMemo, useState, useCallback } from "react";

const useStyles = makeStyles({
    searchInput: {
        marginBottom: 16,
    },
    searchIcon: {
        right: 16,
        top: 4
    }
});

const heading = ["SNo.", "Date", "Name", "Email", "Phone", "Location", "Message"];

const ContactUsList = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [limit, setLimit] = useState(10);
    const [offset, setOffset] = useState(0);
    const [searchText, setSearchText] = useState("");

    const { isLoader, totalCount, contactUsData } = useSelector((state) => state.user);

    useEffect(() => {
        dispatch(getContactUs({limit, offset, searchText}));
    },[limit, offset, searchText, dispatch]);

    const debouncedSave = useMemo(() => 
        debounce((value) => setSearchText(value), 1000), 
        [setSearchText]
    );

    const handleSearchText = useCallback((event) => {
        if(limit === 10 && offset === 0){
            debouncedSave(event.target.value);
        }
        else{
            setLimit(10);
            setOffset(0);
        }
    }, [limit, offset, debouncedSave]);

    const nextClicked = (l, o) => {
        setLimit(l+10);
        setOffset(o+10);
    }

    const prevClicked = (l, o) => {
        setLimit(l-10);
        setOffset(o-10);
    }

    if(isLoader) return ( <PageLoader />)

    return (
        <>
            <div className="container mt-80">
                <div className="position-relative">
                    <div className={`${classes.searchIcon} position-absolute`}>
                        <FaSearch />
                    </div>
                    <input
                        type="text"
                        onChange={handleSearchText}
                        className={`${classes.searchInput} form-control`}
                        placeholder="Search message"
                    />
                </div>
                <Table 
                    data={contactUsData}
                    heading={heading}
                    limit={limit}
                    offset={offset}
                    tableFor="messages"
                    totalCount={totalCount}
                    previous={(limit, offset) => prevClicked(limit, offset)}
                    next={(limit, offset) => nextClicked(limit, offset)}
                />
            </div>
        </>
    )
}
export default ContactUsList;